import {post} from '@/utils/request';
import{erpserver,erpplatserver,attendanceserver} from '@/utils/baseUrl';
//查询假别名称id
// export async function getJqDetailList(params) {
//     return post(erpserver+'/kq/jbList', params, true)
// }
//查询假别名称id
export async function getJqDetailList(params) {
    return post(attendanceserver+'/absenteesim/jbs', params, true)
}
//日历展示假勤
export async function getshowForMonth(params) {
    return post(attendanceserver + '/absenteesim/showForMonth', params, true);
}
export async function detail(params) {
    return post(attendanceserver + '/absenteesim/detail', params, true);
}
//部门树
export async function departTree(params) {
    return post(attendanceserver+'/attendence/departTree', params, true)
}
//搜索框模糊查询
export async function searchUser(params) {
    return post(attendanceserver+'/attendence/searchUser', params, true)
}
//请假信息
export async function dailyDetail(params) {
    return post(attendanceserver+'/absenteesim/dailyDetail', params, true)
}
//保存编辑
export async function savemessage(params) {
    return post(attendanceserver + '/absenteesim/save', params, true);
}
//个人信息
export async function getuserInfo(params) {
    return post(attendanceserver+'/absenteesim/userInfo', params, true)
}
//查询人员
export async function departEmployee(params) {
    return post(attendanceserver+'/attendence/departEmployee', params, true)
}
//分页获取请假加班出差数据
export async function applicationList(params) {
    return post(attendanceserver+'/absenteesim/list', params, true)
}
//作废
export async function canceldetail(params) {
    return post(attendanceserver+'/absenteesim/cancel', params, true)
}
//考勤方案列表
export async function getKqList(params) {
    return post(attendanceserver+'/kq/getKqList', params, true)
}
//获取报表时间
export async function time(params) {
    return post(attendanceserver+'/attendence/kqtc/time', params, true)
}
//文件上传
export async function uploadFile(params) {
    return post(erpplatserver+'/system/uploadFile', params, false)
}
export async function dailySituation(params) {
    return post(attendanceserver+'/absenteesim/dailySituation', params, true)
}